import React, { Fragment } from "react";
import ProductRowLoaders from "components/ProductRowLoaders";
import ActionRowLoader from "components/ActionRowLoader";

const IndexActionLoader = () => (
  <Fragment>
    <ActionRowLoader />
    <div className="pt3">
      <ProductRowLoaders count={10} />
    </div>
  </Fragment>
);

export default IndexActionLoader;
